export const promote = (config) => ({
    ...config
});
//# sourceMappingURL=webhook-webhook-2-to-3.js.map